import { sippableId } from '../index';
import { arraysEqual } from './comparisonUtils';

/**
 * Generates sorted ID arrays for comparison from condition arrays.
 * Uses view:id for new conditions, ratedDisabilityId for rated disabilities,
 * and falls back to sippableId(condition name) for legacy in-progress forms for
 * the super duper edge caset where a user back navigates from a future step.
 * This allows detection of add/delete operations without triggering on edits.
 *
 * @param {Array} conditions - Array of condition objects
 * @returns {string[]} Sorted array of ID strings
 */
export const conditionIds = conditions =>
  (conditions || [])
    .map(c => c['view:id'] || c.ratedDisabilityId || sippableId(c.condition))
    .sort();

/**
 * High-impact field entries for the conditions chapter.
 * When conditions are added or removed, the side navigation resets to prevent
 * navigation to chapters that may contain stale or invalid data.
 *
 * @type {import('./highImpactFields').HighImpactFieldEntry[]}
 */
const CONDITIONS_V2_HIGH_IMPACT_FIELDS = [
  {
    pathMatcher: pathname => pathname === '/conditions/summary',
    field: 'newDisabilities',
    resetToChapter: 1,
    hasImpactfulChange: (oldVal, newVal) =>
      !arraysEqual(conditionIds(oldVal), conditionIds(newVal)),
  },
];

export default CONDITIONS_V2_HIGH_IMPACT_FIELDS;
